<script>
import { fetchFieldRows } from '@/api/ai/index'
export default {
  name: 'ModuleFieldMixin',
  data () {
    return {
      fieldData: {
        selectedRows: []
      }
    }
  },
  methods: {
    // 处理字段类型变化
    handleDataTypeChange (data) {
      // 当数据类型为图片时，禁用且取消勾选搜索条件
      if (data.dataType === 'IMAGE') {
        data.isQueryField = false
      }
    },
    // 创建空属性
    createEmptyField () {
      this.moduleData.current.fields.push({
        frontId: 'field_' + Math.round(Math.random() * 10000),
        fieldType: [],
        dataType: 'TEXT',
        fixed: true,
        isCreateField: true,
        isQueryField: true,
        label: '',
        required: true,
        variable: '',
        rows: [],
        __loading: false
      })
      this.saveToStorage()
    },
    // 处理选中行
    handleFieldsSelectionChange (selectedRows) {
      this.fieldData.selectedRows = selectedRows
    },
    // 删除字段
    deleteField (index) {
      const field = this.moduleData.current.fields[index]
      if (field.variable.trim() === '' && field.label.trim() === '') {
        this.moduleData.current.fields.splice(index, 1)
        this.saveToStorage()
        return
      }
      const fieldsRow = `确认删除${this.moduleData.current.moduleName}中的【${field.label}】字段吗？`
      this.$dialog.deleteConfirm(fieldsRow)
        .then(() => {
          this.moduleData.current.fields.splice(index, 1)
          this.saveToStorage()
        })
        .catch(() => {})
    },
    // 批量删除字段
    deleteFieldsInBatch () {
      this.$dialog.deleteConfirm(`确认删除${this.moduleData.current.moduleName}中的${this.fieldData.selectedRows.length}条记录吗？`)
        .then(() => {
          this.moduleData.current.fields = this.moduleData.current.fields.filter(item => {
            return this.fieldData.selectedRows.findIndex(row => row.frontId === item.frontId) === -1
          })
          this.saveToStorage()
        })
        .catch(() => {})
    },
    // 获取字段数据
    fetchFieldRows (module, field, count) {
      if (field.__loading) {
        return
      }
      field.rows = []
      // 特殊处理：图片，不予加载
      if (field.dataType === 'IMAGE') {
        return
      }
      // 特殊处理：是否xxx
      if (field.label.startsWith('是否')) {
        field.rows.push({
          frontId: 'row_' + Math.round(Math.random() * 10000),
          value: '是'
        })
        field.rows.push({
          frontId: 'row_' + Math.round(Math.random() * 10000),
          value: '否'
        })
        this.saveToStorage()
        return
      }
      field.__loading = true
      fetchFieldRows({
        systemName: this.form.systemName.trim(),
        moduleName: module.moduleName,
        fieldName: field.label
      })
        .then(data => {
          field.rows = window.parseFieldRows(data)
          if (field.rows == null) {
            field.rows = []
          }
          this.saveToStorage()
        })
        .catch(e => {
          if (count < 5) {
            field.loading = false
            this.$nextTick(() => {
              this.fetchFieldRows(module, field, ++count)
            })
            return
          }
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          field.__loading = false
        })
    }
  }
}
</script>
